import { request } from "../../../Services/Api"

export const getRequestsWithdrawal = (params) =>
  request.api.get(`/payments/requests/withdrawal/`, params)
export const deleteWithdrawal = ({ data }) => {
  const { id, admin_screenshots } = data
  const params = new URLSearchParams()
  admin_screenshots.forEach((screenshot) => params.append("id", screenshot?.id))
  return request.api.delete(
    `/payments/requests/withdrawal/${id}/attachments/delete?${params.toString()}`
  )
}

export const getPayoutMethod = (withdrawalId) => {
  return request.api.get(`/referral/admin/withdrawals/${withdrawalId}/payout-method`)
}

export const setStatus = ({ id, status }) => {
  return request.api.post(`/referral/admin/withdrawals/${id}/set-status/`, { status })
}
